<template>
	<div>
		<div class="sousuo" style="width: 100%">
			<div style="width: 450px" class="yl-flex flex_between">
				<Input placeholder="搜索账户名称" v-model="name" style="width: 300px">
				<i-button slot="append" icon="ios-search"></i-button>
				</Input>
				<Button class='ivu-btn-circle' type="primary" @click="search">搜索</Button>
				<Button class='ivu-btn-circle' @click="initSearch">重置</Button>
			</div>
		</div>
		<div class="multiple">
			<div class="child-div">时间区间</div>
			<RadioGroup v-model="timePeriod">
				<DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
					placeholder="选择日期" style="width: 200px"></DatePicker>
			</RadioGroup>
		</div>
		<div class="multiple" style="margin-bottom: 20px;">
			<div class="child-div">搜索条件</div>
			<Select v-model="cidType" style="width:150px;" clearable placeholder="类型">
				<Option v-for="item in cidTypeList" :value="item.id" :key="item.id">{{ item.type }}</Option>
			</Select>
			<Select v-model="city" style="width:150px;" clearable placeholder="城市">
				<Option v-for="item in cityList" :value="item.city" :key="item.city">{{ item.city }}</Option>
			</Select>
			<Select v-model="account" style="width: 100px;margin-left: 10px;width: 150px;" filterable multiple clearable
				placeholder="请选择账户">
				<Option v-for="item in accountList" :value="item.account_id" :key="item.account_id">
					{{ item.account_name}}
				</Option>
			</Select>
			<Select v-model="operationUser" style="width: 100px;margin-left: 10px;width: 150px;" filterable multiple
				clearable placeholder="请选择运营">
				<Option v-for="item in operationList" :value="item.uid" :key="item.uid">
					{{ item.username}}
				</Option>
			</Select>
			<Select v-model="typeSelect" style="width: 100px;margin-left: 10px;width: 150px;" clearable
				placeholder="请选择类型">
				<Option v-for="item in typeList" :value="item.value" :key="item.value">
					{{ item.label}}
				</Option>
			</Select>
		</div>
		<div id="myChart"></div>
		<div style="width: 100% ;margin-top: 20px;">
			<Table stripe border :columns="columns" :data="datas" ref="table">
				<template slot-scope="{ index,row }" slot="type">
					<span style="color:#63B3E6;cursor: pointer;"
						@click.stop="goAdvTypeStaticCity(row.type)">{{row.type}}</span>
				</template>
				<template slot-scope="{ index,row }" slot="average_cost">
					<span v-if="row.average_cost < row.last_average_cost"
						style="color:#55aaff;cursor: pointer;">{{row.average_cost}}<span style="color:#00e500;cursor: pointer;">(<Icon type="md-arrow-round-down" style="color:#00e500;" />{{row.average_cost_rate}}%)</span>
					</span>
					<span v-if="row.average_cost > row.last_average_cost"
						style="color:#55aaff;cursor: pointer;">{{row.average_cost}}<span style="color:#ff0000;cursor: pointer;">(<Icon type="md-arrow-round-up" style="color: #ff0000;" />{{row.average_cost_rate}}%)</span>
					</span>
				</template>
				<template slot-scope="{ index,row }" slot="cost_growth">
					<span v-if="row.average_cost < row.last_average_cost"
						style="color:#00e500;cursor: pointer;">
						<span>{{row.last_average_cost}}</span>
						
					</span>
					<span v-if="row.average_cost > row.last_average_cost"
						style="color:#ff0000;cursor: pointer;">
						<span>{{row.last_average_cost}}</span>
						
					</span>
				</template>
				<template slot-scope="{ index,row }" slot="twoPlusRate">
					<span 
						style="color:#55aaff;cursor: pointer;">{{row.twoPlusRate}}%
					</span>
				</template>
				<template slot-scope="{ index,row }" slot="threePlusRate">
					<span v-if="row.threePlusRate < row.last_threePlusRate"
						style="color:#55aaff;cursor: pointer;">{{row.threePlusRate}}%<span style="color:#ff0000;cursor: pointer;">(<Icon type="md-arrow-round-down" style="color:#ff0000;" />{{(row.threePlusRate - row.last_threePlusRate).toFixed(2)}}%)</span>
					</span>
					<span v-if="row.threePlusRate > row.last_threePlusRate"
						style="color:#55aaff;cursor: pointer;">{{row.threePlusRate}}%<span style="color: #00e500;" >(<Icon type="md-arrow-round-up" style="color: #00e500;" />{{(row.threePlusRate - row.last_threePlusRate).toFixed(2)}}%)</span>
					</span>
				</template>
				<template slot-scope="{ index,row }" slot="threePlus_growth">
					<span v-if="row.threePlusRate < row.last_threePlusRate"
						style="color:#ff0000;cursor: pointer;">
						<span>{{row.last_threePlusRate}}%</span>
						
					</span>
					<span v-if="row.threePlusRate > row.last_threePlusRate"
						style="color:#00e500;cursor: pointer;">
						<span>{{row.last_threePlusRate}}%</span>

					</span>
				</template>
			</Table>
		</div>
		<Modal v-model="advGroupByCityModal" width="1200" title="">
			<AdvTypeGroupByCityStatic :timePeriod="timePeriod" :timePeriodDate="timePeriodDate">
			</AdvTypeGroupByCityStatic>
		</Modal>
	</div>
</template>
<script>
	import {
		mapGetters
	} from "vuex";
	import {
		getAllMediumCode,
		getAllTypeStatic,
		getAdvTypeGroupByCityStaticList,
		getCidTypeList,
		getAdvCityList,
		getToutiaoSrc,
		getAllAccountList,
		getAllOperationList,
		getTimeCycleStatic
	} from "../../api/advManage";
	import AdvTypeGroupByCityStatic from "./components/AdvTypeGroupByCityStatic.vue"
	export default {
		name: "account_static",
		components: {
			AdvTypeGroupByCityStatic
		},
		props: ['AccountStatic'],
		data() {
			return {
				modal: false,
				name: '',
				timePeriod: '2',
				timePeriodDate: [],
				datas: [],
				advGroupByCityModal: false,
				cidType: [1],
				cidTypeList: [],
				cityList: [],
				accountList: [],
				operationList: [],
				operationUser: [],
				city: [],
				account: [],
				typeSelect: 1,
				typeList: [{
						value: 1,
						label: '转化'
					},
					{
						value: 2,
						label: '平均成本'
					},
					{
						value: 3,
						label: '优质成本'
					},
					{
						value: 4,
						label: '优质率'
					},
				],
				columns: [{
						"title": "账户类型",
						"slot": "type",
						"align": "center",
					},
					{
						"title": "城市",
						"key": "city",
						"align": "center",
					},
					{
						"title": "消耗",
						"key": "cost",
						"align": "center",
					},
					{
						"title": "消耗(上周期)",
						"key": "last_cost",
						"align": "center",
					},
					{
						"title": "平均成本",
						"slot": "average_cost",
						"align": "center",
						"width":"150px"
					},
					{
						"title": "平均成本(上周期)",
						"slot": "cost_growth",
						"align": "center",
					},
					{
						"title": "广告转化数",
						"key": "account_convert",
						"align": "center",
					},
					{
						"title": "系统转化数",
						"key": "srcNum",
						"align": "center",
					},
					{
						"title": "数量(上周期)",
						"key": "last_srcNum",
						"align": "center",
					},
					{
						"title": "回传数量",
						"key": "backNum",
						"align": "center",
					},
					{
						"title": "2星+优质率",
						"slot": "twoPlusRate",
						"align": "center",
					},
					{
						"title": "三星+",
						"key": "threePlus",
						"align": "center",
					},
					{
						"title": "优质率",
						"slot": "threePlusRate",
						"align": "center",
						"width":"150px"
					},
					{
						"title": "优质率(上周期)",
						"slot": "threePlus_growth",
						"align": "center",
					},
					{
						"title": "优质成本",
						"key": "threePlusCost",
						"align": "center",
					},
					{
						"title": "优质成本(上周期)",
						"key": "last_threePlusCost",
						"align": "center",
					},
					{
						"title": "1星",
						"key": "one",
						"align": "center",
					},
					{
						"title": "3星",
						"key": "three",
						"align": "center",
					},
					{
						"title": "4星",
						"key": "four",
						"align": "center",
					},
				],
				optionMy: {
					legend: {
						orient: 'horizontal', // 布局方式，默认为水平布局，可选为：
						// 'horizontal' ¦ 'vertical'
						x: 'center', // 水平安放位置，默认为全图居中，可选为：
						// 'center' ¦ 'left' ¦ 'right'
						// ¦ {number}（x坐标，单位px）
						y: 'top', // 垂直安放位置，默认为全图顶端，可选为：
						// 'top' ¦ 'bottom' ¦ 'center'
						// ¦ {number}（y坐标，单位px）
						backgroundColor: 'rgba(0,0,0,0)',
						borderColor: '#ccc', // 图例边框颜色
						borderWidth: 0, // 图例边框线宽，单位px，默认为0（无边框）
						padding: 5, // 图例内边距，单位px，默认各方向内边距为5，
						// 接受数组分别设定上右下左边距，同css
						itemGap: 10, // 各个item之间的间隔，单位px，默认为10，
						// 横向布局时为水平间隔，纵向布局时为纵向间隔
						itemWidth: 20, // 图例图形宽度
						itemHeight: 14, // 图例图形高度
						selected:{
							'本周转化':true,
							'上周转化':true,
							'本周成本':true,
							'上周成本':true,
							'本周优质成本':false,
							'上周优质成本':false,
							'本周优质率':false,
							'上周优质率':false,
							
						},
						textStyle: {
							color: '#333' // 图例文字颜色
						},
					},
					title: {
						text: ''
					},
					tooltip: {},
					xAxis: {
						data: []
					},
					yAxis: [{
							type: 'value',
							name: '成本',
							position: "left",
							offset: 0,
							min: 0,

						},
						{
							type: 'value',
							name: '数量',
							position: "left",
							offset: 70,
							min: 0,
							interval: 100,

						},
						{
							type: 'value',
							name: '优质率',
							min: 0,
							max: 100,
							interval: 25,
							splitNumber: 6, //设置坐标轴的分割段数
						}
					],
					series: [{
							name: '本周转化',
							type: 'bar',
							yAxisIndex: 0,
							color: '#35a57a',
							data: [],
							itemStyle: {
								normal: {
									label: {
										show: true, //是否展示
										textStyle: {
											fontWeight: 'bolder',
											fontSize: '12',
											fontFamily: '微软雅黑',
										}
									}
								}
							}
						}, {
							name: '上周转化',
							type: 'bar',
							yAxisIndex: 0,
							color: '#64a58b',
							data: [],
							itemStyle: {
								normal: {
									label: {
										show: true, //是否展示
										textStyle: {
											fontWeight: 'bolder',
											fontSize: '12',
											fontFamily: '微软雅黑',
										}
									}
								}
							}
						},
						{
							name: '本周成本',
							type: 'bar',
							yAxisIndex: 1,
							color: '#ac593d',
							data: [],
							itemStyle: {
								normal: {
									label: {
										show: true, //是否展示
										textStyle: {
											fontWeight: 'bolder',
											fontSize: '12',
											fontFamily: '微软雅黑',
										}
									}
								}
							}
						}, {
							name: '上周成本',
							type: 'bar',
							yAxisIndex: 1,
							color: '#ea7953',
							data: [],
							itemStyle: {
								normal: {
									label: {
										show: true, //是否展示
										textStyle: {
											fontWeight: 'bolder',
											fontSize: '12',
											fontFamily: '微软雅黑',
									}
										}
								}
							}
						},
						{
							name: '本周优质成本',
							type: 'bar',
							yAxisIndex: 1,
							color: '#556fb9',
							data: [],
							itemStyle: {
								normal: {
									label: {
										show: true, //是否展示
										textStyle: {
											fontWeight: 'bolder',
											fontSize: '12',
											fontFamily: '微软雅黑',
									}
										}
								}
							}
						}, {
							name: '上周优质成本',
							type: 'bar',
							yAxisIndex: 1,
							color: '#6d92ee',
							data: [],
							itemStyle: {
								normal: {
									label: {
										show: true, //是否展示
										textStyle: {
											fontWeight: 'bolder',
											fontSize: '12',
											fontFamily: '微软雅黑',
										}
									}
								}
							}
						},
						{
							name: '本周优质率',
							type: 'bar',
							yAxisIndex: 2,
							color: '#ad2249',
							data: [],
							itemStyle: {
								normal: {
									label: {
										show: true, //是否展示
										textStyle: {
											fontWeight: 'bolder',
											fontSize: '12',
											fontFamily: '微软雅黑',
										}
									}
								}
							}
						}, {
							name: '上周优质率',
							type: 'bar',
							yAxisIndex: 2,
							color: '#ff326c',
							data: [],
							itemStyle: {
								normal: {
									label: {
										show: true, //是否展示
										textStyle: {
											fontWeight: 'bolder',
											fontSize: '12',
											fontFamily: '微软雅黑',
										}
									}
								}
							}
						}
					]
				}
			}
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted: function() {
			this.loadData();
			this.getList();
		},
		methods: {

			timePeriodDateChange(e) {
				this.timePeriodDate = e
			},
			initSearch() {
				this.name = '';
				this.timePeriod = '2';
				this.timePeriodDate = [];
				this.cidType = [1];
				this.city = [];
				this.account = [];
				this.operationUser = [];
				this.getList();
			},
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getCidTypeList(that, data);
				that.cidTypeList = res.data.list
				res = await getAdvCityList(that, data);
				that.cityList = res.data.list
				res = await getToutiaoSrc(that, data);
				that.srcList = res.data.list;
				res = await getAllAccountList(that, data);
				that.accountList = res.data.list;
				res = await getAllOperationList(that, data);
				that.operationList = res.data.list;
			},
			goAdvTypeStaticCity() {
				this.advGroupByCityModal = true;
			},
			async getList() {
				let that = this;
				var data = this.$data;
				data.token = this.token;
				data.cidType = this.cidType;
				data.city = this.city;
				data.account = this.account;
				data.operationUser = this.operationUser;
				let res = await getTimeCycleStatic(that, data);
				let myChart = this.$echarts.init(document.getElementById("myChart"));
				that.datas = res.data.list;
				//图表准备
				var obj = that.datas;
				var sxAxis = [];
				var thisTimeSrcNum = [];
				var lastTimeSrcNum = [];
				var thisTimeAverageCost = [];
				var lastTimeAverageCost = [];
				var thisTimeThreePlusCost = [];
				var lastTimeThreePlusCost = [];
				var thisTimeThreePlusRate = [];
				var lastTimeThreePlusRate = [];
				//坐标和数据都push到数组中
				for (var i = 0; i < obj.length; i++) {
					sxAxis.push(
						obj[i].city + obj[i].type
					);

					thisTimeSrcNum.push(
						obj[i].srcNum
					);
					lastTimeSrcNum.push(
						obj[i].last_srcNum
					);

					thisTimeAverageCost.push(
						obj[i].average_cost
					);
					lastTimeAverageCost.push(
						obj[i].last_average_cost
					);

					thisTimeThreePlusCost.push(
						obj[i].threePlusCost
					);
					lastTimeThreePlusCost.push(
						obj[i].last_threePlusCost
					);

					thisTimeThreePlusRate.push(
						obj[i].threePlusRate
					);
					lastTimeThreePlusRate.push(
						obj[i].last_threePlusRate
					);


				}
				that.optionMy.xAxis.data = sxAxis;
				that.optionMy.series[0].data = thisTimeSrcNum;
				that.optionMy.series[1].data = lastTimeSrcNum;
				that.optionMy.series[2].data = thisTimeAverageCost;
				that.optionMy.series[3].data = lastTimeAverageCost;
				that.optionMy.series[4].data = thisTimeThreePlusCost;
				that.optionMy.series[5].data = lastTimeThreePlusCost;
				that.optionMy.series[6].data = thisTimeThreePlusRate;
				that.optionMy.series[7].data = lastTimeThreePlusRate;
				console.log(that.optionMy)
				myChart.clear();
				myChart.setOption(this.optionMy);

			},
			search() {
				this.getList();
			}
		},


	}
</script>
<style scoped lang="less">
	#myChart {
		width: 100%;
		height: 700px;
		background-color: #FFFFFF;
		padding-top: 30px;
	}

	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	.ivu-table table {
		width: 100% !important;
	}

	.green-bg {
		background: #18bc9c;
	}

	.blue-bg {
		background: #54A1F3;
	}

	.person {
		font-size: 14px;
		color: white;
		border-radius: 50%;
		width: 22px;
		height: 20px;
	}

	.in-block {
		display: inline-block;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>
